import MediaOverlay from '@/components/MediaOverlay/MediaOverlay';

import { HighlightMediaTextProps } from './HighlightMediaTextFull';
import useStyles from './HighlightMediaTextFull.styles';
import InnerContent from './InnerContent';

const VideoFull = (props: HighlightMediaTextProps) => {
  const { isOnDark, video, imageSources } = props;
  const { classes, cx } = useStyles({ isOnDark });

  if (!video?.fields && !video?.fields?.videoUrl) return <div />;
  const videoFields = video?.fields;

  const videos = {
    fallback: videoFields.videoUrl,
  };

  return (
    <MediaOverlay
      videos={videos}
      images={imageSources}
      overlayClassName={classes.mediaOverlay}
      mode='desktopOnly'
    >
      <div className={cx(classes.innerContent, classes.videoInnerContent)}>
        <InnerContent {...props} />
      </div>
    </MediaOverlay>
  );
};

export default VideoFull;
